module.exports = __webpack_public_path__ + "static/media/MasterBath1.c1f08d46.jpg";